module.exports = __webpack_public_path__ + "media/images/custom_page/toz_event/toz-event-zh-ef0b8705a8165ce7dda2be4432db7979.png";